var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBilling = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.86,
    height: 12,
    viewBox: "0 0 10.86 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "receipt_long_FILL0_wght300_GRAD-25_opsz24",
    d: "M148.837-831.421a1.522,1.522,0,0,1-1.108-.451,1.487,1.487,0,0,1-.458-1.1v-1.513H149.2v-8.934l.891.752.89-.752.89.752.9-.752.89.752.89-.752.9.752.89-.752.9.752.877-.752v10.447a1.487,1.487,0,0,1-.458,1.1,1.522,1.522,0,0,1-1.108.451Zm7.728-.913a.645.645,0,0,0,.465-.18.6.6,0,0,0,.188-.455v-9.037h-7.1v7.52h5.809v1.513a.622.622,0,0,0,.18.459A.622.622,0,0,0,156.565-832.334Zm-5.657-7.291v-.913h3.624v.913Zm0,1.932v-.913h3.624v.913Zm4.973-1.844a.524.524,0,0,1-.384-.161.524.524,0,0,1-.161-.384.524.524,0,0,1,.161-.384.524.524,0,0,1,.384-.161.524.524,0,0,1,.384.161.524.524,0,0,1,.161.384.524.524,0,0,1-.161.384A.524.524,0,0,1,155.881-839.537Zm0,1.932a.524.524,0,0,1-.384-.161.524.524,0,0,1-.161-.384.524.524,0,0,1,.161-.384.524.524,0,0,1,.384-.161.524.524,0,0,1,.384.161.524.524,0,0,1,.161.384.524.524,0,0,1-.161.384A.524.524,0,0,1,155.881-837.605Zm-7.046,5.271h6.177v-1.24h-6.828v.6a.611.611,0,0,0,.187.459A.641.641,0,0,0,148.834-832.334Zm-.65,0v0Z",
    transform: "translate(-147.271 843.421)",
    fill: "#3b3b3b"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBilling, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/billing.0a12293d.svg";
export { ForwardRef as ReactComponent };